import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject;

import { AsyncButton, SocialAuthButton, UnavailableInLens } from '@infl-ts/ui-advocate-components';
import Twitter from '@mui/icons-material/Twitter';
import { buttonClasses, circularProgressClasses, darken, styled } from '@mui/material';
import { Translation } from 'react-i18next';
import { jsx as _jsx } from "react/jsx-runtime";
var TwitterAsyncButton = styled(AsyncButton)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  background: ", ";\n  color: ", ";\n\n  &.", " {\n    background: ", ";\n\n    .", " {\n      color: ", ";\n    }\n  }\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.palette.other.twitter;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.palette.common.white;
}, buttonClasses.disabled, function (_ref3) {
  var status = _ref3.status,
      theme = _ref3.theme;
  return status === 'success' ? theme.palette.success.main : darken(theme.palette.other.twitter, 0.2);
}, circularProgressClasses.root, function (_ref4) {
  var theme = _ref4.theme;
  return darken(theme.palette.secondary.main, 0.2);
});

var TwitterButton = function TwitterButton(_ref5) {
  var defaultText = _ref5.defaultText,
      completedText = _ref5.completedText,
      savingText = _ref5.savingText,
      onClick = _ref5.onClick,
      connected = _ref5.connected,
      authUrl = _ref5.authUrl,
      status = _ref5.status,
      isPreview = _ref5.isPreview;
  return /*#__PURE__*/_jsx(UnavailableInLens, {
    tooltip: true,
    "data-element": "UnavailableInLens",
    "data-component": "TwitterButton",
    "data-source-file": "twitter-button.tsx",
    children: connected || isPreview ? /*#__PURE__*/_jsx(TwitterAsyncButton, {
      status: status,
      sx: {
        mx: 1,
        ml: 0
      },
      size: "large",
      variant: "contained",
      disabled: status === 'success',
      onClick: onClick,
      text: [savingText !== null && savingText !== void 0 ? savingText : defaultText, defaultText, completedText, defaultText],
      startIcon: status === 'default' || status === 'error' ? /*#__PURE__*/_jsx(Twitter, {}) : undefined
    }) : /*#__PURE__*/_jsx(Translation, {
      children: function children(t) {
        return /*#__PURE__*/_jsx(SocialAuthButton, {
          sx: {
            background: function background(t) {
              return t.palette.other.twitter;
            },
            '&:hover': {
              background: function background(t) {
                return t.palette.other.twitter;
              }
            }
          },
          authUrl: authUrl.replace(/origin=[^&]*&/i, "origin=".concat(encodeURIComponent(window.location.href), "&")),
          text: t('Connect to Twitter')
        });
      }
    })
  });
};

export default TwitterButton;